import { Card, Dropdown, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Scrollbar from 'components/base/Scrollbar';
import Button from 'components/base/Button';
import NotificationItem from 'components/common/NotificationItem';
import classNames from 'classnames';
import { TNotification } from 'utils/types';

type NotificationDropdownMenuProps = {
  className?: string;
  notifications: TNotification[];
  isLoading: boolean;
  onItemClick: (notification: TNotification) => void;
  onMarkAllRead: () => void;
  unreadCount: number;
};

const NotificationDropdownMenu = ({
  className,
  notifications,
  isLoading,
  onItemClick,
  onMarkAllRead,
  unreadCount
}: NotificationDropdownMenuProps) => {
  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-dropdown-caret py-0 notification-dropdown-menu shadow border'
      )}
      style={{ minWidth: '32rem', width: '32rem' }}
    >
      <Card className="position-relative border-0">
        <Card.Header className="p-2">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="text-body-emphasis mb-0">Notifications</h5>
            {unreadCount > 0 && (
              <Button
                variant="link"
                className="p-0 fs-9 fw-normal"
                onClick={onMarkAllRead}
              >
                Mark all as read
              </Button>
            )}
          </div>
        </Card.Header>
        <Card.Body className="p-0" style={{ height: '27rem' }}>
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <Spinner animation="border" size="sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Scrollbar>
              {notifications.length === 0 ? (
                <p className="text-body-secondary fs-9 text-center py-4 mb-0">
                  No notifications yet.
                </p>
              ) : (
                notifications.map((notification, index) => (
                  <NotificationItem
                    notification={notification}
                    type="dropdownItem"
                    onClick={() => onItemClick(notification)}
                    className={classNames({
                      'border-bottom border-translucent':
                        index !== notifications.length - 1
                    })}
                    key={notification.notificationId}
                  />
                ))
              )}
            </Scrollbar>
          )}
        </Card.Body>
        <Card.Footer className="p-0 border-top">
          <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
            <Link to="/notifications" className="fw-bolder">
              View all
            </Link>
          </div>
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default NotificationDropdownMenu;
